export const authorizeMethod = "mining.authorize";
export const authorize = '{"id":"mining.authorize","method":"mining.authorize","params":["<worker.name>","<worker.pass>"]}\n';
export const subscribeMethod = "mining.subscribe";
export const subscribe = '{"id": "mining.subscribe", "method": "mining.subscribe", "params": ["<worker.agent>"]}\n';
export const subscribeExtra = '{"id": "mining.extranonce.subscribe", "method": "mining.extranonce.subscribe", "params": []}\n';
export const miningDifficulty = "mining.set_difficulty";
export const miningNotify = "mining.notify";
export const submitMethod = "mining.submit";
export const submitWork = '{"params": ["<worker.name>", "<jobID>", "<ExtraNonce2>", "<ntime>", "<nonce>"], "id": "mining.submit", "method": "mining.submit"}\n'